import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const configuratorPageK = {
  products: "configurator_page.products",
  getStartedByClickingNewConfiguration: "configurator_page.getStartedByClickingNewConfiguration",
  selectProduct: "configurator_page.selectProduct",
  selectSystem: "configurator_page.selectSystem",
  noSystemsFound: "configurator_page.noSystemsFound",
  configurations: "configurator_page.configurations",
  deleteConfiguration: "configurator_page.deleteConfiguration",
  partsList: "configurator_page.partsList",
  newConfiguration: "configurator_page.newConfiguration",
  label: "configurator_page.label",
  addLabel: "configurator_page.addLabel",
  systems: "configurator_page.systems",
  productInformation: "configurator_page.productInformation",
  noConfigurations: "configurator_page.noConfigurations",
  areYouSureYouWantToDeleteThisProductConfiguration: "configurator_page.areYouSureYouWantToDeleteThisProductConfiguration",
  productIsMissingInformation: "configurator_page.productIsMissingInformation",
  configuration: "configurator_page.configuration",
  product: "configurator_page.product",
  system: "configurator_page.system",
  noProductsFound: "configurator_page.noProductsFound",
  addDoorFrame: "configurator_page.addDoorFrame",
  areYouSureYouWantToDeleteThisWholeConfiguration: "configurator_page.areYouSureYouWantToDeleteThisWholeConfiguration",
  areYouSureYouWantToDeleteSelectedConfiguration: "configurator_page.areYouSureYouWantToDeleteSelectedConfiguration",
  selectProductAndSave: "configurator_page.selectProductAndSave",
};

export const useConfiguratorPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      products: t(configuratorPageK.products),
      getStartedByClickingNewConfiguration: t(configuratorPageK.getStartedByClickingNewConfiguration),
      selectProduct: t(configuratorPageK.selectProduct),
      selectSystem: t(configuratorPageK.selectSystem),
      noSystemsFound: t(configuratorPageK.noSystemsFound),
      configurations: t(configuratorPageK.configurations),
      deleteConfiguration: t(configuratorPageK.deleteConfiguration),
      partsList: t(configuratorPageK.partsList),
      newConfiguration: t(configuratorPageK.newConfiguration),
      label: t(configuratorPageK.label),
      addLabel: t(configuratorPageK.addLabel),
      systems: t(configuratorPageK.systems),
      productInformation: t(configuratorPageK.productInformation),
      noConfigurations: t(configuratorPageK.noConfigurations),
      areYouSureYouWantToDeleteThisProductConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteThisProductConfiguration),
      productIsMissingInformation: t(configuratorPageK.productIsMissingInformation),
      configuration: t(configuratorPageK.configuration),
      product: t(configuratorPageK.product),
      system: t(configuratorPageK.system),
      noProductsFound: t(configuratorPageK.noProductsFound),
      addDoorFrame: t(configuratorPageK.addDoorFrame),
      areYouSureYouWantToDeleteThisWholeConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteThisWholeConfiguration),
      areYouSureYouWantToDeleteSelectedConfiguration: t(configuratorPageK.areYouSureYouWantToDeleteSelectedConfiguration),
      selectProductAndSave: t(configuratorPageK.selectProductAndSave),
    }),
    [i18n.language]
  );
};